import {Component, OnInit, Input, ViewChild, ElementRef} from '@angular/core';
import {Table} from 'primeng/table';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.css']
})
export class GridComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  @Input() items: any[] = [];
  @Input() cols: any[] = [];
  @Input() width: any;
  @Input() name: string = 'data';
  column1Width: string = 'width: 115px';

  constructor() { }

  ngOnInit(): void {
    if(window.innerWidth < 500) this.column1Width = '';
  }

  isNumber(value: any): boolean {
    return !isNaN(value);
  }

  csvDownload(): void {
    if(this.dt) this.dt.exportCSV()
  }
}
